import * as React from "react";
import { forwardRef } from "react";
const SvgStarFillIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 1L15.6184 8.01969L23.4127 9.2918L17.8547 14.9023L19.0534 22.7082L12 19.156L4.94657 22.7082L6.14528 14.9023L0.587311 9.2918L8.38158 8.01969L12 1Z" }));
const ForwardRef = forwardRef(SvgStarFillIcon);
export { ForwardRef as ReactComponent };
